<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <page-title :title="'Registo chamadas'"
                            :subtitle="'Observações registadas relativamente a cada interação de chamada.'"/>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-simple-table v-if="callsInteractionList.length > 0" dense class="staff_table">
                    <thead>
                        <tr>
                            <th width="6%">Data</th>
                            <th width="6%" class="text-center">ID_Chamada</th>
                            <th width="6%" class="text-center">Tipo</th>
                            <th class="text-center" width="5%">Telefone</th>
                            <th class="text-center" width="8%">Agente</th>
                            <th>Cliente</th>
                            <th>Observações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="10" class="text-center pa-10">
                                <v-progress-circular
                                        indeterminate
                                        color="error"
                                ></v-progress-circular>
                            </td>
                        </tr>
                        <tr v-if="!loading" class="filters_row">
                            <td>
                                <v-text-field
                                        v-model="filters.date"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.id_call"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.type"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.phone"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                            <td style="max-width: 100px">
                                <v-text-field
                                        v-model="filters.agent"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.client"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                        v-model="filters.obs"
                                        outlined
                                        hide-details
                                        single-line
                                        @keyup="filteredLines"
                                >
                                </v-text-field>
                            </td>
                        </tr>
                        <!-- CALLS ROWS -->
                        <tr v-if="!loading" v-for="(callInteraction, key) in filteredCallsInteractions">
                            <td>{{ callInteraction.created_at.substring(0,19) }}</td>
                            <td class="text-center"> {{ callInteraction.call_uniqueid }} </td>
                            <td class="text-center">
                                <v-chip
                                        v-if="callInteraction.call_type === 'recebida'"
                                        color="success"
                                        x-small
                                        style="text-transform: uppercase"
                                >
                                    {{ callInteraction.call_type }}
                                </v-chip>
                                <v-chip
                                        v-else
                                        color="info"
                                        x-small
                                        style="text-transform: uppercase"
                                >
                                    {{ callInteraction.call_type }}
                                </v-chip>
                            </td>
                            <td class="text-center">{{ callInteraction.contact_number }}</td>
                            <td class="text-center">
                                {{ callInteraction.agent_extension }} - {{callInteraction.agent}}
                            </td>
                            <td>
                                <div v-if="!callInteraction.final_client">
                                    <strong>{{ callInteraction.entity }}</strong> - {{ callInteraction.client }}
                                    <a :href="'/clients/clients/' + callInteraction.entity" target="_blank">
                                        <v-icon class="ml-1" size="14" color="info">mdi-open-in-new</v-icon>
                                    </a>
                                </div>
                                <div v-else>
                                    <span class="pa-1" style="background-color: #00C853;font-weight: bold;color: white;border-radius: 4px">CF</span>
                                    {{ callInteraction.client }}
                                </div>
                            </td>
                            <td>{{ callInteraction.observations }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
export default {
    data: () => ({
        loading: false,
        callsInteractionList: [],
        filteredCallsInteractions: [],
        filters: {
            date: '',
            id_call: '',
            type: '',
            phone: '',
            agent: '',
            client: '',
            obs: ''
        },
    }),
    mounted() {
        this.getCallsInteractions();
    },
    methods: {
        getCallsInteractions(){
            this.loading = true;
            // let loader = this.$loading.show();
            let request = { url: '/api/staff/customer-service/interaction-call'}

            ApiWS.dispatch('makeGet', request)
                    .then(response => {
                        let responseData = response.data

                        this.callsInteractionList = responseData;
                        this.filteredCallsInteractions = this.callsInteractionList;

                        // loader.hide();
                        this.loading = false;
                    })
                    .catch(() => {
                        Alert.dispatch('show', {
                            snackbar: true,
                            text: 'Erro de servidor!',
                            type: 'error'
                        })
                        // loader.hide();
                        this.loading = false;
                    })
        },
        filteredLines() {
            this.filteredCallsInteractions = this.callsInteractionList;
            
            if (this.filters.date !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.created_at.substring(0,19).toUpperCase().includes(this.filters.date.toUpperCase()))
            }
            if (this.filters.id_call !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.call_uniqueid.toUpperCase().includes(this.filters.id_call.toUpperCase()))
            }
            if (this.filters.type !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.call_type.toUpperCase().includes(this.filters.type.toUpperCase()))
            }
            if (this.filters.phone !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.contact_number.toUpperCase().includes(this.filters.phone.toUpperCase()))
            }
            if (this.filters.agent !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.agent_extension.toUpperCase().includes(this.filters.agent.toUpperCase()) || item.agent.toUpperCase().includes(this.filters.agent.toUpperCase()))
            }
            if (this.filters.client !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.final_client ? item.client.toUpperCase().includes(this.filters.client.toUpperCase()) : (item.entity.toUpperCase().includes(this.filters.client.toUpperCase()) || item.client.toUpperCase().includes(this.filters.client.toUpperCase())))
            }
            if (this.filters.obs !== '') {
                this.filteredCallsInteractions = this.filteredCallsInteractions.filter(item => item.observations.toUpperCase().includes(this.filters.obs.toUpperCase()))
            }
        },
    }
}
</script>
<style scoped>

</style>